
import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
  user: localStorage.getItem("user") || {},
  token: localStorage.getItem("token") || "",
  routeHistory: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.user = action?.payload?.user;
      state.token = action?.payload?.token;
    },
    logoutUser: (state, action) => {
      state.user = "";
      state.token = "";
    },
    addToHistory: (state, action) => {
      const path = action.payload;
      const validPaths = ["/", "/seller", "/product-details", "/category", "/mobile-search-result", "/top-grocery-stores"]
      if (path === '/') {
        state.routeHistory = ['/'];
      }
      else if (validPaths.includes(path)) {
        const indexOf = state.routeHistory.indexOf(path);
        if (indexOf !== -1) {
          state.routeHistory?.splice(indexOf, 1);
        }
        state.routeHistory?.push(path);
      }
    },
  },
});

export const { loginUser, logoutUser, addToHistory } = userSlice.actions;

export default userSlice.reducer;

